import pushManager from './pushManager';

class SWManager {
    constructor() {
        if (SWManager._instance) {
            return SWManager._instance;
        }

        SWManager._instance = this;
    }

    async destroy() {
        await this.unregisterServiceWorker();
        delete SWManager._instance;
    }

    async initialize(app, notificationCallback) {
        this.app = app;

        if ('serviceWorker' in navigator) {
            try {
                console.log('Registering Service worker...');
                const registration = await navigator.serviceWorker.register('service-worker.js');
                this.registration = registration;
                pushManager.initialize(registration, app, notificationCallback);
            } catch(err) {
                console.warn('Service worker registration failed, error:', err);
            }
        } else {
            console.warn('Service workers are not supported.');
        }
    }

    async unregisterServiceWorker() {
        if ('serviceWorker' in navigator) {
            try {
                console.log('Unregistering Service worker...');
                await pushManager.destroy();
                await this.registration.unregister();
            } catch (err) {
                console.warn('Service worker unregistration failed, error:', err);
            }
        }
    }

    // send message to service worker
    sendMessage(message) {
        return new Promise((resolve, reject) => {
            if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage(message);
                resolve();
            } else {
                reject('No service worker controller');
            }
        });
    }
}

SWManager._instance = undefined;

export default new SWManager();
